/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the desired horizontal alignment of the cell content.
 */
export var CellContentHorizontalAlignment = /*@__PURE__*/ (function (CellContentHorizontalAlignment) {
    /**
     * Align left.
     */
    CellContentHorizontalAlignment[CellContentHorizontalAlignment["Left"] = 0] = "Left";
    /**
     * Align center.
     */
    CellContentHorizontalAlignment[CellContentHorizontalAlignment["Center"] = 1] = "Center";
    /**
     * Align right.
     */
    CellContentHorizontalAlignment[CellContentHorizontalAlignment["Right"] = 2] = "Right";
    /**
     * Align stretch
     */
    CellContentHorizontalAlignment[CellContentHorizontalAlignment["Stretch"] = 3] = "Stretch";
    /**
     * Align auto
     */
    CellContentHorizontalAlignment[CellContentHorizontalAlignment["Auto"] = 4] = "Auto";
    return CellContentHorizontalAlignment;
})({});
/**
 * @hidden
 */
export var CellContentHorizontalAlignment_$type = /*@__PURE__*/ markEnum('CellContentHorizontalAlignment', 'Left,0|Center,1|Right,2|Stretch,3|Auto,4');
//# sourceMappingURL=CellContentHorizontalAlignment.js.map
